import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';
// import buildExportQuery from './queryies/_export_all';
import { saveAs } from 'file-saver';
import moment from 'moment';

interface OrdersState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: OrdersState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_CLIENT_LIST';

const COLUMNS: any = {
    id: 'deals.id',
    name: 'deals.name',
    expected_delivery_date: 'deals.expected_delivery_date',
    status: 'status.name',
    status_color: 'status.color',
    address: 'point.address',
    counterparty: 'counterparty.name',
    payment_type: 'payment_type.name',
    payment_deferment_period: 'payment_deferment_periods.name',
    containers: {
      $array_agg: {
        $obj: {
          id: 'deal_product_containers.id',
          name: 'products.name',
          promo_name: 'products.promo_name',
          container_name: 'product_containers.name',
          container_quantity: 'deal_product_containers.container_quantity',
          container_price: 'deal_product_containers.container_price',
          container_weight: {$mul: ['deal_product_containers.container_quantity', 'product_containers.weight']},
          notes: 'deal_product_containers.notes',
          base_price: 'personal_settings.container_price',
          base_weight: 'product_containers.weight',
        }
      }
    },
    weight: {
      $sum: {
        $case: [
          [
            'product_containers.price_per_kg',
            'deal_product_containers.container_weight'
          ],
          [
            {
              $: true
            },
            {
              $mul: [
                'product_containers.weight',
                'deal_product_containers.container_quantity'
              ]
            }
          ]
        ]
      },
    },
    price: {
      $sum: 'deal_product_containers.container_price',
    },
};

export function build_query(query: any, client_id: any, limit: number = 10) {
    const filter: any[] = [];
    filter.push({
      $or: [
          {$eq: ['vpc.id', {$: client_id}]},
          {$eq: ['vpc.client_id', {$: client_id}]}
      ]
    })
    if (query.copy) {
      filter.push({
        $eq: ['deals.id', {$: query.copy}]
      })
    }
    if (query.delivery_point_id) {
      filter.push({
        $eq: ['deals.delivery_point_id', {$: query.delivery_point_id}]
      })
    }
    if (query.delivery_only) {
      filter.push({
        $not: [ { $eq: ['deals.status_id', {$: 'd:statuses:19'}] } ]
      })
    }
    return {
        "columns": COLUMNS,
        from: 's:deals',
        from_as: 'deals',
        joins: [
          {
            join: 's:view_client_parents',
            as:   'vpc',
            on: {
              $eq: ['vpc.client_id', 'deals.client_id']
            }
          },
          {
            join: 's:statuses',
            as:   'status',
            on: {
              $eq: ['status.id', 'deals.status_id']
            }
          },
          {
            join: 's:delivery_points',
            type: 'left',
            as:   'point',
            on: {
              $eq: ['deals.delivery_point_id', 'point.id']
            }
          },
          {
            join: 's:counterparties',
            type: 'left',
            as:   'counterparty',
            on: {
              $eq: ['deals.counterparty_id', 'counterparty.id']
            }
          },
          {
            join: 's:payment_types',
            type: 'left',
            as:   'payment_type',
            on: {
              $eq: ['deals.payment_type_id', 'payment_type.id']
            }
          },
          {
            join: 's:clients',
            type: 'left',
            as:   'client',
            on: {
              $eq: ['deals.client_id', 'client.id']
            }
          },
          {
            join: 's:payment_deferment_periods',
            type: 'left',
            as:   'payment_deferment_periods',
            on: {
              $eq: ['payment_deferment_periods.id', 'client.payment_deferment_period_id']
            }
          },
          {
              join: 's:deal_product_containers',
              type: 'left',
              as: 'deal_product_containers',
              on: {
                  $eq: ['deal_product_containers.deal_id', 'deals.id']
              }
          },
          {
            join: 's:product_containers',
            type: 'left',
            as: 'product_containers',
            on: {
              $eq: ['product_containers.id', 'deal_product_containers.product_container_id']
            }
          },
          {
            join: 's:products',
            type: 'left',
            as: 'products',
            on: {
              $eq: ['products.id', 'product_containers.product_id']
            }
          },
          {
            join: 's:client_product_containers',
            type: 'left',
            as:   'personal_settings',
            on: {
              $and: [
                { $eq: ['personal_settings.product_container_id', 'product_containers.id'] },
                { $eq: ['personal_settings.client_id', 'deals.client_id' ] }
              ]
            }
          }
        ],
        page_size: limit,
        ...({page: parseInt(query.page) || 1}),
        groups: [
          'deals.id', 'deals.name', 'status.name', 'point.address', 'deals.expected_delivery_date', 'status.color',
          'counterparty.name', 'payment_type.name', 'payment_deferment_periods.name'
        ],
        order: [query.last ? { $desc: ['deals.expected_delivery_date' ] } : { $desc: ['deals.id' ] }],
        ...(
            filter.length > 1 ?
            {
                "where": {
                    "$and": filter
                }
            } : {
                "where": filter[0]
            }
        )

    }
}


export const actions: ActionTree<OrdersState, RootState> = {
    loadData({ commit, rootState, getters, dispatch }, query) {
        const vm = (this as any)._vm;
        const client_id = (rootState as any).ubic.actor.document.client_id

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action(build_query(query, client_id))
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },
};

export const mutations: MutationTree<OrdersState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_orders';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
